export const AUTH_EVENTS = {
  signInStarted: 'auth_signin_started',
  signInFailed: 'auth_signin_failed',
  login: 'auth_login',
  signUp: 'auth_sign_up',
  signOut: 'auth_signout',
  accountDeleted: 'auth_account_deleted',
} as const;

export type AuthEventNameType = (typeof AUTH_EVENTS)[keyof typeof AUTH_EVENTS];
